import { useState, useEffect } from "react";
import client from "../client/api";
import CONSTANTS from "../constants";
import history from "../routes/helper/history";
import useQuery from "../routes/helper/useQueryHooks";
import buildForm from "./buildForm";
import { buildHeaders } from "./buildHeaders";

import parseErrorClient from "../utils/parseErrorClient";

const RecorvyPasswordHooks = () => {
  const query = useQuery();
  const token = query.get("token");
  const user = query.get("user");
  const location = window.location;
  const [errorResponse, setError] = useState();
  const [loading, setloading] = useState(false);
  const [expiredToken, setExpiredToken] = useState(null);
  const [hasSend, setHasSend] = useState(false);
  const hasTokenRequest = query.has("token");

  if (!user && hasTokenRequest) history.push(CONSTANTS.APP.LOGIN);

  const handleRecorvy = async (event) => {
    event.preventDefault();
    try {
      setloading("aguarde...");
      const body = {
        ...buildForm(event.target),
        grantType: 'password'
      }
      console.log(body)
      await client.post(
        `${CONSTANTS.API.RECOVERY}?callback_url=${location.href}`,
          body,
        buildHeaders({ token })
      );
      setloading(false);
      setHasSend(true);
    } catch (error) {
      parseErrorClient(error, setloading, setError);
    }
  };

  const handleNewPassword = async (event) => {
    event.preventDefault();
    try {
      setloading("aguarde...");
      await client.patch(
        `${CONSTANTS.API.USER}/${user}`,
        buildForm(event.target),
        buildHeaders({ token })
      );
      setloading(false)
      setHasSend(true)
    } catch (error) {
      parseErrorClient(error, setloading, setError);
    }
  };

  const handleRedirect = (e) => {
    e.preventDefault();
    location.href = CONSTANTS.APP.RECOVERY
  };

  const handleHasSend = (e) => {
    e.preventDefault();
    history.push(CONSTANTS.APP.LOGIN);
  };

  useEffect(() => {
    if (hasTokenRequest && expiredToken == null && loading) {
      client
        .get(CONSTANTS.API.RECOVERY, buildHeaders({ token }))
        .then(() => {
          setExpiredToken(false);
          setloading(false);
        })
        .catch((err) => {
          if (err.response?.status === 401) {
              setExpiredToken(true);
              setloading(false);
          }
          else parseErrorClient(err, setloading, setError);
        });
    } else if (hasTokenRequest && !loading && expiredToken == null) {
      setloading("Conectando ao servidor");
    }
  }, [loading]);
  return {
    handleRecorvy,
    handleNewPassword,
    handleHasSend,
    handleRedirect,
    errorResponse,
    hasTokenRequest,
    loading,
    token,
    expiredToken,
    hasSend,
  };
};

export default RecorvyPasswordHooks;
